import { ApiClient, createApi } from "@repo/api-client";

// Every api route is served under /api, and the browser always reaches it on
// the origin that served this page: Caddy in production, Vite's proxy in
// development. So the base URL is a constant, there is no environment variable
// to set, and the built assets are portable across every environment.
const client = new ApiClient({ baseUrl: "/api" });

export const api = createApi(client);
